import { createAsyncThunk } from '@reduxjs/toolkit';

import { payment } from 'src/api';

export const createPaymentAddress = createAsyncThunk('payment/createPaymentAddress', async (data: any, thunkAPI) => {
  try {
    const response = await payment.createPaymentAddress(data);

    if (response.status === 401) {
      return thunkAPI.rejectWithValue('401 Unauthorized');
    }

    if (!response.ok) {
      const json = await response.json();

      return thunkAPI.rejectWithValue(json);
    }

    return await response.json();
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error);
  }
});
